import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import markerIcon from '../../../assets/icons/marker.svg';
import calendarIcon from '../../../assets/icons/calendar.svg';
import heartIcon from '../../../assets/icons/heart.svg';
import heartIconActive from '../../../assets/icons/bottomBar/active_heart.svg';
import placeholderImage from '../../../assets/images/noimage.png';

import { addToFavorites, removeFromFavorites } from "../../../api/favoritecall";
import { formatPrice } from '../../../utils/formatPrice';
import formatDate from '../../../utils/formatDate';

const GREY_FILTER = '[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(0%)_saturate(0%)_brightness(90%)]';

const CategoryAdItem = ({ item }) => {
    const [isFavorite, setIsFavorite] = useState(item.is_favorite || false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsFavorite(item.is_favorite || false);
    }, [item.is_favorite]);

    const handleFavoriteToggle = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            navigate('/sign');
            return;
        }

        try {
            if (isFavorite) {
                await removeFromFavorites(item.id);
                setIsFavorite(false);
            } else {
                await addToFavorites(item.id);
                setIsFavorite(true);
            }
        } catch (error) {
            console.error("Error toggling favorite:", error);
            setIsFavorite(!isFavorite);
        }
    };

    const handleClick = () => {
        navigate(`/announcement/${item.id}`);
    };

    const hasLocation =
        (item.location && (item.location.province || item.location.locality)) ||
        false;

    return (
        <div
            className="cursor-pointer bg-white rounded-xl overflow-hidden flex flex-col w-full text-left hover:shadow-md transition-shadow duration-200"
            onClick={handleClick}
        >
            {/* Image */}
            <div className="relative">
                <img
                    className="w-full h-[160px] md:h-[140px] object-cover"
                    src={item.main_image_url || placeholderImage}
                    alt={item.title}
                    onError={(e) => {
                        if (e.target.src !== placeholderImage) {
                            e.target.onerror = null;
                            e.target.src = placeholderImage;
                        }
                    }}
                />
                {/* Favorite button */}
                <button
                    className="absolute right-2 top-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm hover:scale-110 transition-transform duration-150"
                    onClick={handleFavoriteToggle}
                >
                    <img
                        src={isFavorite ? heartIconActive : heartIcon}
                        alt="like"
                        className="w-4 h-4"
                    />
                </button>
            </div>

            {/* Content */}
            <div className="p-3 flex flex-col gap-1.5 flex-1">
                <h3 className="m-0 text-[13px] font-semibold text-[#222222] leading-snug line-clamp-2">
                    {item.title}
                </h3>
                <p className="m-0 text-[14px] font-bold text-[#147F26]">
                    {formatPrice(item.price, item.price_type, item.is_negotiable, item.barter)}
                </p>

                <div className="flex flex-col gap-1 mt-auto pt-1">
                    {hasLocation && (
                        <div className="flex items-center gap-1">
                            <img src={markerIcon} alt="" className={`w-3 h-3 shrink-0 ${GREY_FILTER}`} />
                            <span className="text-[11px] text-[#939393] truncate">
                                {item.location?.province && `${item.location.province}, `}
                                {item.location?.locality || ''}
                            </span>
                        </div>
                    )}
                    <div className="flex items-center gap-1">
                        <img src={calendarIcon} alt="" className={`w-3 h-3 shrink-0 ${GREY_FILTER}`} />
                        <span className="text-[11px] text-[#939393]">{formatDate(item.created_at)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryAdItem;
